import Storage from '@/helpers/storage'

export default {

    terms: {

        accept: function () {

            const today = new Date().toISOString().split('T')[0]

            Storage.setItem('termsUpdate', today)

        },

        acceptedTime: function () {

            return Storage.getItem('termsUpdate')

        }

    }

}
